import is from "./7th-grade.json";
import junior from "./junior.json";
import middle from "./middle.json";

export const data = {
  "information-security-7th-grade": is,
  junior,
  middle,
};
